import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpRequest from "../../utils/httpRequest";
import { BASE_URL } from "../../config/settings";

export const generateRemitaPayment = createAsyncThunk(
  "payment/generateRemitaPayment",
  async (feePaymentId, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Payment/${feePaymentId}/generate-remita`,
        "post"
      );
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const confirmRemitaPayment = createAsyncThunk(
  "payment/confirmRemitaPayment",
  async (referenceId, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Payment/confirm-remita-payment/${referenceId}`,
        "post"
      );
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const initiatePaystackPayment = createAsyncThunk(
  "payment/initiatePaystackPayment",
  async (feePaymentId, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Payment/paystack/initiate-payment?feePaymentId=${feePaymentId}`,
        "post"
      );
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const verifyPaystackPayment = createAsyncThunk(
  "payment/verifyPaystackPayment",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Payment/paystack/verify?referenceId=${queryParams}`,
        "get"
      );
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    loading: false,
    error: null,
    data: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(generateRemitaPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateRemitaPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(generateRemitaPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(confirmRemitaPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(confirmRemitaPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(confirmRemitaPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(initiatePaystackPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(initiatePaystackPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(initiatePaystackPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(verifyPaystackPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyPaystackPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(verifyPaystackPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default paymentSlice.reducer;
